module.exports = __webpack_public_path__ + "static/cover@2x-01da721ad0cf618f403934b7982d7aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/cover@2x.jpg
// module id = 114
// module chunks = 3627797113349 20562973939449 33019919093843